<div class="timezone-dialog" [class.automatic]="automatic" [attr.aria-busy]="busy">
    <button class="close" type="button" (click)="close()" [disabled]="busy" [attr.aria-label]="text('Закрити', 'Close')">×</button>
    <ng-container *ngIf="automatic; else manual">
        <h2>{{ text('Змінити часовий пояс', 'Change time zone') }}</h2>
        <p>{{ text('Ваш поточний часовий пояс визначено як', 'Your current time zone is') }}</p>
        <strong>{{ timezones.offset(detected) }}</strong>
        <p>{{ text('Ви можете оновити відображення часу занять дитини відповідно до даного часового поясу або залишити часовий пояс за замовчуванням —', 'You can display your children’s lessons in this time zone or keep the default time zone —') }}
            {{ timezones.offset('Europe/Kyiv') }} Kyiv.
            {{ text('За потреби ви завжди можете змінити часовий пояс, натиснувши на позначку в хедері.', 'You can change it later using the time zone badge in the header.') }}</p>
        <div class="actions">
            <button class="skip" type="button" [disabled]="busy" (click)="save('Europe/Kyiv')">{{ text('ПРОПУСТИТИ', 'SKIP') }}</button>
            <button class="update" type="button" [disabled]="busy" (click)="save(detected)">{{ text('ОНОВИТИ', 'UPDATE') }}</button>
        </div>
    </ng-container>
    <ng-template #manual>
        <div class="zones" role="radiogroup" [attr.aria-label]="text('Часовий пояс', 'Time zone')">
            <label *ngFor="let zone of zones">
                <input type="radio" name="timezone" [value]="zone" [(ngModel)]="selected" [disabled]="busy">
                <span>{{ zone.replace('_', ' ').split('/').join(' / ') }} <small>{{ timezones.offset(zone) }}</small></span>
            </label>
        </div>
        <div class="actions manual-actions">
            <button type="button" [disabled]="busy" (click)="close()">{{ text('Скасувати', 'Cancel') }}</button>
            <button class="update" type="button" [disabled]="busy" (click)="save(selected)">{{ text('Оновити', 'Update') }}</button>
        </div>
    </ng-template>
    <p *ngIf="error" class="error" role="alert">{{ text('Не вдалося зберегти часовий пояс. Спробуйте ще раз.', 'Could not save the time zone. Please try again.') }}</p>
</div>
